import React from "react";
import {
  ShieldCheck,
  Hammer,
  Clock3,
  HandshakeIcon,
  Sparkles,
  HardHat,
} from "lucide-react";

const REASONS = [
  {
    icon: HardHat,
    title: "Owner on every job",
    body: "No bait-and-switch crews. The estimator is the project manager is the lead carpenter.",
  },
  {
    icon: ShieldCheck,
    title: "Fully licensed & insured",
    body: "$2M general liability. Workers' comp. Lead-safe certified. We bring our paperwork to the first walkthrough.",
  },
  {
    icon: Clock3,
    title: "Schedules we keep",
    body: "Realistic timelines, daily check-ins, and zero ghosting. If we're 30 minutes late, you'll know why.",
  },
  {
    icon: Hammer,
    title: "Real craft, real prep",
    body: "Subfloor leveled. Walls floated. Waterproofing done before tile. The unsexy stuff is where we shine.",
  },
  {
    icon: Sparkles,
    title: "Daily clean-down",
    body: "We protect floors, vacuum at end of day, and haul our trash. You can still live in your house while we work.",
  },
  {
    icon: HandshakeIcon,
    title: "2-year workmanship warranty",
    body: "Written, signed, and honored. If something we built fails, we fix it. No drama, no invoice.",
  },
];

const WhyChooseUs = () => {
  return (
    <section
      data-testid="why-choose-us"
      className="py-24 lg:py-32 bg-brand-ink text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-paper opacity-[0.04]" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-6">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-4 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              Why JMJC
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
              The boring stuff <br />
              <span className="italic font-light">other guys skip.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="text-base lg:text-lg text-white/70 leading-relaxed">
              Anybody can pour mud and slap on tile. We're the people you call
              when you've already been burned and need it done right this time.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`reason-${i}`}
                className="bg-brand-ink p-8 lg:p-10 flex flex-col gap-5 hover:bg-brand-ink/60 transition-colors group"
              >
                <div className="w-12 h-12 border border-brand-cta flex items-center justify-center group-hover:bg-brand-cta transition-colors">
                  <Icon
                    className="w-5 h-5 text-brand-cta group-hover:text-white transition-colors"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-heading text-xl font-bold tracking-tight">
                  {r.title}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed">
                  {r.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
